/* global Stripe */
// custom.js
const rules = {
    card_number: value => Stripe.card.validateCardNumber(value),
    expiry_month_year: {
        validate(month, [year]) {
            return Stripe.card.validateExpiry(month, year);
        },
        options: {
            hasTarget: true
        }
    },
    security_code: value => Stripe.card.validateCVC(value)
};

// export an 'install' function.
export default Validator => {
    // for every rule we defined above.
    Object.keys(rules).forEach(rule => {
        //  add the rule.
        Validator.extend(rule, rules[rule], rules[rule]["options"]);
    });
};
